var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7211 8.39961C27.7211 8.39961 27.4477 6.46914 26.6055 5.62148C25.5391 4.50586 24.3469 4.50039 23.8 4.43477C19.8844 4.15039 14.0055 4.15039 14.0055 4.15039H13.9945C13.9945 4.15039 8.11562 4.15039 4.2 4.43477C3.65313 4.50039 2.46094 4.50586 1.39453 5.62148C0.552344 6.46914 0.284375 8.39961 0.284375 8.39961C0.284375 8.39961 0 10.6691 0 12.9332V15.0551C0 17.3191 0.278906 19.5887 0.278906 19.5887C0.278906 19.5887 0.552344 21.5191 1.38906 22.3668C2.45547 23.4824 3.85547 23.4441 4.47891 23.5645C6.72109 23.7777 14 23.8434 14 23.8434C14 23.8434 19.8844 23.8324 23.8 23.5535C24.3469 23.4879 25.5391 23.4824 26.6055 22.3668C27.4477 21.5191 27.7211 19.5887 27.7211 19.5887C27.7211 19.5887 28 17.3246 28 15.0551V12.9332C28 10.6691 27.7211 8.39961 27.7211 8.39961ZM11.107 17.6309V9.76133L18.6703 13.7098L11.107 17.6309Z",
    fill: "#FAFBFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtubeWhite.dd2b4f51ad731a775fdcc2bfdb92db83.svg";
export { ForwardRef as ReactComponent };